/**
 * @generated SignedSource<<4ec3c12fbf641f30aa26959c220b9aaa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PreferencesDialog_query$data = {
  readonly analytics: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly value: string;
      };
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"useProblemsAlert_problems">;
  };
  readonly whoami: {
    readonly displayName: string | null | undefined;
  };
  readonly " $fragmentType": "PreferencesDialog_query";
};
export type PreferencesDialog_query$key = {
  readonly " $data"?: PreferencesDialog_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"PreferencesDialog_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PreferencesDialog_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrentUser",
      "kind": "LinkedField",
      "name": "whoami",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "analytics",
      "args": [
        {
          "kind": "Literal",
          "name": "filterElement",
          "value": {
            "single": {
              "name": "name",
              "operator": "equals",
              "value": "analytics_enabled"
            }
          }
        }
      ],
      "concreteType": "UserDataConnection",
      "kind": "LinkedField",
      "name": "userData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserDataEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserData",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useProblemsAlert_problems"
        }
      ],
      "storageKey": "userData(filterElement:{\"single\":{\"name\":\"name\",\"operator\":\"equals\",\"value\":\"analytics_enabled\"}})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "5ed1207176a94fffd37c5235bf13d272";

export default node;
